import { render, staticRenderFns } from "./huijiao.vue?vue&type=template&id=52cf1a63&scoped=true"
import script from "./huijiao.vue?vue&type=script&lang=js"
export * from "./huijiao.vue?vue&type=script&lang=js"
import style0 from "./huijiao.vue?vue&type=style&index=0&id=52cf1a63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cf1a63",
  null
  
)

export default component.exports